import { Box } from "@mui/material";
import { SummaryRoomList } from "../rooms/summary-room-list/SummaryRoomList";
import { UserProfile } from "../user/profile/UserProfile";
import { CreateRoomButton } from "../rooms/create/CreateRoomButton";


export function IMPageContent(){

    return <Box>
        <CreateRoomButton />
        <UserProfile />
        <SummaryRoomList />
    </Box>
}